import React, { useEffect, useState, useRef } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import _isFunction from 'lodash/isFunction.js';
import _findIndex from 'lodash/findIndex.js';
import { useEventListener } from '../hooks/useEventListener.js';
import { ColorPreviewTile } from './ColorPreviewTile.jsx';
import { useDragScroll } from '../hooks/useDragScroll.js';

export function ColorPicker(props) {

  const { 
    colors, 
    metallicColors, 
    showColorName,
    initColorCode,
    onChangeCallback
  } = props;

  const block = 'c-color-picker';
  const scrollContainerRef = useRef();
  const initColorIndexRef = useRef(initColorCode ? _findIndex(colors, colorObj => (colorObj.code || colorObj.image.colorCode) === initColorCode) : 0);
  const [activeColor, setActiveColor] = useState(initColorIndexRef.current);
  const [displayName, setDisplayName] = useState(colors[activeColor].name);
  const [isOverflowing, setIsOverflowing] = useState();
  const dragEvents = useDragScroll({ 
    onScrollCallback: scrollPosition => {
      setIsOverflowing(scrollPosition !== 'end');
    },
  });

  function updateActiveColor(e, color, index) {
    setActiveColor(index);
  };

  function checkScrollOverflow() {
    const el = scrollContainerRef.current;
    const isOverflowing = el.scrollWidth > el.offsetWidth;
    setIsOverflowing(isOverflowing);
  };

  useEventListener('resize', checkScrollOverflow);

  useEffect(() => {
    if (_isFunction(onChangeCallback)) {
      onChangeCallback(colors[activeColor]);
    }
  }, [activeColor]);

  useEffect(() => {
    checkScrollOverflow();
  }, []);

  return (
    <div 
    className={classNames({
      [block]: true,
      [`${block}--is-overflowing`]: isOverflowing
    })}
    >
    {
      showColorName &&
        <div className={`${block}__option-display-name h6`}>{ displayName }</div>
    } 
      <div 
      className={`${block}__option-selector-scroll-container`}
      ref={scrollContainerRef}
      { ...dragEvents }
      >
      { 
        colors.map((color, index) => (
          <ColorPreviewTile 
          color={color} 
          index={index} 
          active={index === activeColor}
          metallic={metallicColors}
          onClickCallback={updateActiveColor}
          key={`color-value-${index}`}
          /> 
        ))
      }
      </div>
    </div>
  )
};

ColorPicker.propTypes = {
  colors: propTypes.array.isRequired,
  metallicColors: propTypes.bool,
  showColorName: propTypes.bool,
  onChangeCallback: propTypes.func
};
